"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalHamburguerMenu_styled_exports = {};
__export(GlobalHamburguerMenu_styled_exports, {
  StyledButton: () => StyledButton,
  StyledDrawer: () => StyledDrawer,
  StyledError: () => StyledError,
  StyledListItem: () => StyledListItem,
  StyledSeparator: () => StyledSeparator,
  StyledUnorderedList: () => StyledUnorderedList
});
module.exports = __toCommonJS(GlobalHamburguerMenu_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_mixins = require("../../../themes/mixins");
var import_atoms = require("../../atoms");
var StyledUnorderedList = import_styled_components.default.ul.withConfig({
  displayName: "GlobalHamburguerMenustyled__StyledUnorderedList",
  componentId: "sc-ttdhdk-0"
})(function(_ref) {
  var theme = _ref.theme;
  return (0, import_styled_components.css)(["padding:0;margin-top:0;background-color:", ";"], theme.colors.white);
});
var StyledListItem = import_styled_components.default.li.withConfig({
  displayName: "GlobalHamburguerMenustyled__StyledListItem",
  componentId: "sc-ttdhdk-1"
})(["list-style:none;"]);
var StyledButton = (0, import_styled_components.default)(import_atoms.Button).withConfig({
  displayName: "GlobalHamburguerMenustyled__StyledButton",
  componentId: "sc-ttdhdk-2"
})(function(_ref2) {
  var isActive = _ref2.isActive, disabled = _ref2.disabled, theme = _ref2.theme;
  return (0, import_styled_components.css)(["cursor:", ";color:", ";background-color:", ";& i{color:", ";}&:hover{background-color:", ";color:", ";}&:active{box-shadow:none;}"], disabled ? "not-allowed" : "pointer", isActive && !disabled ? theme.colors.black : theme.colors.beige[180], theme.colors.transparent.base, disabled ? theme.colors.beige[140] : isActive ? theme.colors.n[100] : theme.colors.pr.base, disabled ? theme.colors.transparent.base : theme.colors.beige[60], isActive && !disabled ? theme.colors.black : theme.colors.beige[180]);
});
var StyledSeparator = import_styled_components.default.div.withConfig({
  displayName: "GlobalHamburguerMenustyled__StyledSeparator",
  componentId: "sc-ttdhdk-3"
})(function(_ref3) {
  var theme = _ref3.theme;
  return (0, import_styled_components.css)(["background:", ";width:100%;height:1px;"], theme.colors.beige[140]);
});
var StyledDrawer = (0, import_styled_components.default)(import_atoms.Drawer).withConfig({
  displayName: "GlobalHamburguerMenustyled__StyledDrawer",
  componentId: "sc-ttdhdk-4"
})(function() {
  return (0, import_styled_components.css)(["height:calc(100% - 88px);", ""], (0, import_mixins.mediaBreakpointUp)("md", "\n      height: calc(100% - 56px);\n    "));
});
var StyledError = import_styled_components.default.div.withConfig({
  displayName: "GlobalHamburguerMenustyled__StyledError",
  componentId: "sc-ttdhdk-5"
})(function(_ref4) {
  var theme = _ref4.theme;
  return (0, import_styled_components.css)(["display:flex;flex-direction:column;align-items:center;margin-top:102px;span{width:126px;text-align:center;font-family:", ";font-weight:450;line-height:20px;font-size:", ";margin-bottom:16px;}svg{margin-bottom:4px;}"], theme.typography.fonts.primary, theme.typography.sizes.small);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledButton,
  StyledDrawer,
  StyledError,
  StyledListItem,
  StyledSeparator,
  StyledUnorderedList
});
//# sourceMappingURL=GlobalHamburguerMenu.styled.js.map